import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import size from 'lodash/size';
import orderBy from 'lodash/orderBy';

import format from 'date-fns/format';
import parse from 'date-fns/parse';
import * as queryString from "query-string/index";
import { useHistory, useLocation } from "react-router";
import SearchResults from "../components/SearchResults";
import { getResultsSuccess, setResultsLoaded } from "../redux/results/action";
import { getVendors, setVendorsLoaded } from "../redux/vendors/action";
import LoadingVendors from "../components/LoadingVendors";
import SearchCarWidget from "../components/SearchCarWidget";
import routes from '../constants/routes.json';
import FilterWidget from "../components/FilterWidget";
import { MAX_REQUEST_COUNT, MAX_REQUEST_PER_SECOND, DEFAULT_FILTERS } from "../constants/default";
import { useTranslation } from 'react-i18next';
import { getCookie } from '../utils/cookies';
import SmartFilterWidget from '../components/SmartFilterWidget';
import { djb2Hash } from '../utils/djb2Hash';
import { filterResults, normalizeFilterValue } from '../utils/filterUtils';

function Search({ dispatch, results, vendors, resultsLoaded, resultsLastCheck, vendorsLoaded, loading, dir, cur, currencies, vendorsLoading, vendorsLastCheck, locations, cid }) {
  // console.log('creating search container...')
  const attributor = window.sessionStorage.getItem("attributor") ? window.sessionStorage.getItem("attributor") : getCookie('attributor')
  const [params, setParams] = useState();
  const location = useLocation();
  const history = useHistory();
  const [counter, setCounter] = useState(0);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const { t, i18n } = useTranslation();
  const [getVendorsIfNeeded, tryToGetVendorsIfNeeded] = useState(false);

  let isAirport = false
  let locationSlug = ''
  if (params && params.fromLocationCode) {
    const puLocations = Array.isArray(locations) && locations.filter(loc => loc.locationCode == params.fromLocationCode)
    const puLocation = puLocations.length > 0 && puLocations[puLocations.length - 1]
    isAirport = puLocation && puLocation.IATA && puLocation.IATA.length === 3
    locationSlug = puLocation ? `${puLocation?.country}-${puLocation?.city}-${puLocation?.IATA}`.toLocaleLowerCase() : ''
  }

  useEffect(() => {
    const params = queryString.parse(location.search);
    let { endDate, startDate, fromLocationCode, toLocationCode, age, ...rest } = params;
    setParams({ endDate, startDate, fromLocationCode, toLocationCode, age });
    // Normalize all filter values to arrays
    const normalizedFilters = {};
    Object.keys(rest).forEach(key => {
      normalizedFilters[key] = normalizeFilterValue(rest[key]);
    });
    if (Object.keys(rest).length === 0) {
      // console.log('setting filters to default')
      setFilters(DEFAULT_FILTERS);
    } else {
      setFilters(normalizedFilters);
    }
    history.push({
      pathname: routes.SEARCH,
      search: `${queryString.stringify({ ...params, ...rest })}`
    })
  }, []); // eslint-disable-line

  // useEffect(() => {

  // }, [window.gtag])

  const fetchResults = () => {

    if (!vendorsLoaded && counter < MAX_REQUEST_COUNT) {
      setTimeout(() => {
        tryToGetVendorsIfNeeded(true);
      }, 1000 / MAX_REQUEST_PER_SECOND);
    } else {
      dispatch(setVendorsLoaded(true));
      dispatch(setResultsLoaded(true));
    }
    // }
  };

  useEffect(() => {
    if (getVendorsIfNeeded) {
      tryToGetVendorsIfNeeded(false);
      if (!vendorsLoading && !vendorsLoaded && counter < MAX_REQUEST_COUNT) {
        if (params) {
          const payload = {
            puLocation: params.fromLocationCode,
            doLocation: params.toLocationCode,
            puDate: params.startDate,
            doDate: params.endDate,
            filter: JSON.stringify({
              age: params.age
            }),
          };

          const query = queryString.stringify(payload, { encode: false });
          dispatch(getVendors({ query }));
        }
      }

      setCounter(counter + 1);
    }
  }, [getVendorsIfNeeded])

  useEffect(() => {
    if (params && !vendorsLoaded && !vendorsLoading) {
      fetchResults();
    }
  }, [params, counter, vendorsLastCheck]); // eslint-disable-line

  useEffect(() => {
    // tracking
    // tood: track age
    if (params && params.startDate && params.endDate) {
      const puDate = parse(params.startDate.replace('T', ' '), 'dd/MM/yyyy HH:mm', new Date());
      const doDate = parse(params.endDate.replace('T', ' '), 'dd/MM/yyyy HH:mm', new Date());
      const daysToTrip = Math.round((puDate - Date.now()) / (60 * 60 * 24 * 1000));
      const tripDays = Math.round((doDate - puDate) / (60 * 60 * 24 * 1000));
      trackDaysToPickup(daysToTrip);
      trackRentalDuration(tripDays);
    }
    // originally we were pulling cid here. it is moved to app level because I need it on homepage too.
  }, [params]); // eslint-disable-line


  useEffect(() => {
    if (vendorsLoaded) { // Vendors loaded
      let items = [];

      forEach(vendors, (group, key) => {

        if (group) {
          items = [...items, ...map(group.data, item => ({ ...item, key }))]
        }
      });

      setTimeout(() => {
        dispatch(getResultsSuccess(items));
        setCounter(0);
      }, 1000 / MAX_REQUEST_PER_SECOND);
    }
  }, [vendorsLoaded]);

  const trackDaysToPickup = (days) => {
    if (window.gtag) {
      window.gtag('event', 'Days to pickup', {
        'event_category': 'Travel Length',
        // 'event_label': days,
        'value': days
      })
    }
  }

  const trackRentalDuration = (days) => {
    if (window.gtag) {
      window.gtag('event', 'Rental duration', {
        'event_category': 'Travel Length',
        // 'event_label': days,
        'value': days
      })
    }
  }

  const onSubmit = fields => {
    const params = {
      startDate: `${format(fields.startDate, 'dd/MM/yyyy')}T${fields.hoursFrom}:${fields.minsFrom}`,
      endDate: `${format(fields.endDate, 'dd/MM/yyyy')}T${fields.hoursTo}:${fields.minsTo}`,
      fromLocationCode: fields.fromLocation.locationCode,
      toLocationCode: fields.toLocation.locationCode,
      age: fields.age,
      cur: cur,
      ...DEFAULT_FILTERS,
    };
    setParams(params);
    setFilters(DEFAULT_FILTERS); // clear filters on every search

    dispatch(setVendorsLoaded(false));
    dispatch(setResultsLoaded(false));
    // no need to apply lang because path is "search" so it remains on whatever lang prefix we are at anyway
    history.push({
      pathname: routes.SEARCH,
      search: `${queryString.stringify(params)}`
    })
  };

  // Starting 08/09/20
  // onApplyFilters is obsolete as long as onFilterChange act on any filter change
  // const onApplyFilters = () => {
  //   setQueryFilters(filters);

  //   history.push({
  //     pathname: routes.SEARCH,
  //     search: `${queryString.stringify({...params, ...filters})}`
  //   })
  // };

  const onClearFilters = filters => {
    setFilters(DEFAULT_FILTERS);

    // no need to apply lang because path is "search" so it remains on whatever lang prefix we are at anyway
    history.push({
      pathname: routes.SEARCH,
      search: `${queryString.stringify({ ...params, ...DEFAULT_FILTERS })}`
    })
  };

  const onFilterChange = values => {
    const newFilters = { ...filters, ...values };
    setFilters(newFilters);

    history.push({
      pathname: routes.SEARCH,
      search: `${queryString.stringify({ ...params, ...newFilters })}`
    })
  };

  const convertCurrency = (sourceCurrency, targetCurrency, sourceValue) => {
    return sourceValue * currencies[targetCurrency] / currencies[sourceCurrency]
  }

  // generic query filters are automatically dealt with. Here we extract the filters with non trivial logic
  const sortResults = (data) => {
    const { sortPrice } = filters;
    let result = [...data];
    if (sortPrice) {
      result = orderBy(result, ['payment.total'], [sortPrice])
    }
    return result;
  };

  const manipulateResults = (data) => {
    return data.map(item => {
      const newItem = { ...item }

      // Generate a unique offer ID using key attributes
      const offerKey = [
        newItem.model || '',
        newItem.group || '',
        newItem.localSupplier?.displayName || '',
        newItem.terms?.kmLimit || '',
        newItem.terms?.basicCoverageIncluded || '',
        newItem.terms?.excessRefundIncluded || '',
        newItem.payment?.payNow != newItem.payment?.total,
        newItem.key || '',
        newItem.terms.zeroExcess || false,
      ].join('|');
      newItem.id = djb2Hash(offerKey).toString();

      // adding tracking to easycar and rentalcars deeplink
      if (newItem.deeplink) {
        if (newItem.deeplink.indexOf('rentalcars.com') > -1 || newItem.deeplink.indexOf('cars.booking.com') > -1) {
          // rentalcars uses unique country lang br for pt-BR and pt for pt-PT
          const linkLang = i18n.language.indexOf('pt') > -1 ? i18n.language.substring(3, 2).toLowerCase() : i18n.language.substring(0, 2)
          newItem.deeplink += `&adcamp=${attributor}&adplat=${cid}&preflang=${linkLang}&prefcurrency=${cur}&cor=IL`
        } else if (newItem.deeplink.indexOf('easycar.com') > -1) {
          const parsedUrl = queryString.parseUrl(newItem.deeplink, { parseFragmentIdentifier: true });
          parsedUrl.query.campaign = attributor
          parsedUrl.query.clickref = cid
          // hack - the stringify behavior is to encode the "/" chars in the fragment, so I have to postfix the fragment manually
          newItem.deeplink = queryString.stringifyUrl({ url: parsedUrl.url, query: parsedUrl.query });
          newItem.deeplink += `#${parsedUrl.fragmentIdentifier}`
        } else if (newItem.deeplink.indexOf('arguscarhire.com') > -1) {
          const parsedUrl = queryString.parseUrl(newItem.deeplink, { parseFragmentIdentifier: true });
          parsedUrl.query.orderID = `${cid}-${attributor}`
          parsedUrl.query.curr = ['USD', 'EUR', 'GBP'].includes(cur) ? cur : 'EUR'; // for the moment we only allow USD, EUR & GBP due to bug in argus
          parsedUrl.query.lang = i18n.language.substring(0, 2)
          // hack - the stringify behavior is to encode the "/" chars in the fragment, so I have to postfix the fragment manually
          newItem.deeplink = queryString.stringifyUrl({ url: parsedUrl.url, query: parsedUrl.query });
          newItem.deeplink += `#${parsedUrl.fragmentIdentifier}`
        } else if (newItem.deeplink.indexOf('discovercars.com') > -1) {
          newItem.deeplink = newItem.deeplink.replace('discovercars.com/en/', `discovercars.com/${i18n.language.substring(0, 2)}/`)
          newItem.deeplink += `&data1=${cid}&data2=${attributor}`

          // hack - manipulate deeplink to travelpayouts
          // newItem.deeplink = newItem.deeplink.split('?')[0]
          // newItem.deeplink = `https://tp.media/r?marker=422039.${cid}&trs=219900&p=3555&u=${encodeURIComponent(newItem.deeplink)}&campaign_id=117`
          // } else if (newItem.deeplink.indexOf('rent4less.co.il') > -1) {
          //   newItem.deeplink += `&refId${getRandomInt(1,999)}=${cid}`
        } else if (newItem.deeplink.indexOf('hertz.co.il') > -1) {
          if (i18n.language.substring(0, 2) === 'en') { // hertz only support he and en. he comes from api by default
            newItem.deeplink = newItem.deeplink.replace('/he/', '/en/')
          }
        } else if (newItem.deeplink.indexOf('barkro.com') > -1) {
          newItem.deeplink += `&note=${cid}`
        }
      }

      // manipulate currency
      if (newItem.payment.total && newItem.payment.currency) {
        newItem.payment.renderTotal = convertCurrency(newItem.payment.currency, cur, newItem.payment.total)
        newItem.payment.renderPayNow = convertCurrency(newItem.payment.currency, cur, newItem.payment.payNow)
        newItem.payment.renderCurrency = cur
      }

      // consolidate from DesktopItem and MobileItem logic
      if (newItem.terms && newItem.terms.currency && typeof newItem.terms.currency !== 'object') {
        if (typeof newItem.terms.excess !== 'undefined') {
          newItem.terms.zeroExcess = newItem.terms.excess === 0;
          // item.terms.excess = item.terms.excess.toLocaleString(locale, { style: 'currency', currency: item.terms.currency });
        }
        // if (typeof item.terms.deposit !== 'undefined') {
        //   item.terms.deposit = item.terms.deposit.toLocaleString(locale, { style: 'currency', currency: item.terms.currency });
        // }
        // if (typeof item.terms.noShowCost !== 'undefined') {
        //   item.terms.noShowCost = item.terms.noShowCost.toLocaleString(locale, { style: 'currency', currency: item.terms.currency });
        // }
        // if (typeof item.terms.excess !== 'undefined') {
        //   item.terms.excess = item.terms.excess.toLocaleString(locale, { style: 'currency', currency: item.terms.currency });
        // }
      }

      // add vat note for israel locations except of eilat
      if (newItem.puLocation < 100 && newItem.puLocation !== 4 && newItem.puLocation !== 18) {
        console.log('adding something')
        if (newItem.payment.vatIncluded) {
          newItem.payment.vatNote = t("vatIncludedText")
        } else {
          newItem.payment.vatNote = t("vatNotIncludedText")
        }
      }

      // calculate branch rating (was in Rating.js)
      if (newItem.localSupplier && newItem.localSupplier.googlePlace) {
        const googlePlace = newItem.localSupplier.googlePlace;
        if (googlePlace.rating > 3 && googlePlace.userRatingsTotal > 30) {
          googlePlace.ratingString = "recommended";
        } else {
          googlePlace.ratingString = "notRecommended";
        }
      }

      return newItem
    });
  };

  // const prepareResults = data => {
  //   let result = filterResults(data);
  //   result = sortResults(result);
  //   result = manipulateResults(result);
  //   return result;
  // };

  // Split prepareResults into filterResults, sortResults, and manipulateResults
  // console.log(`preping results...`)
  const allResults = sortResults(manipulateResults(results))
  const filteredResults = filterResults(allResults, filters, isAirport)

  // console.log('before render', filters)
  return (

    <Container fluid className="search-wrapper flex-fill px-0 px-lg-3 min-vh-100">
      {!resultsLoaded && <LoadingVendors dir={dir} data={vendors} progress={Math.round(counter / MAX_REQUEST_COUNT * 100)} />}

      {resultsLoaded && (
        <Row noGutters={true}>
          <Col md={4} sm={12} style={{ maxWidth: "500px" }}>
            <SearchCarWidget dir={dir} onSubmit={onSubmit} params={params} minimized={true} />
            {size(allResults) > 0 ?
              <FilterWidget
                data={allResults}
                activeFilters={filters}
                onChange={onFilterChange}
                onClear={onClearFilters}
                // onApply={onApplyFilters}
                isAirport={isAirport}
                locationSlug={locationSlug} />
              : ""
            }
          </Col>
          <Col md={8} sm={12}>
            <SmartFilterWidget
              dir={dir}
              data={allResults}
              activeFilters={filters}
              isAirport={isAirport}
              onChange={onFilterChange}
              onClear={onClearFilters} />
            {size(allResults) > 0
              ? <SearchResults 
                  dir={dir} 
                  data={filteredResults} 
                  allResults={allResults} 
                  onClear={onClearFilters} 
                  cid={cid} 
                  attributor={attributor} 
                  isAirport={isAirport} 
                  locationSlug={locationSlug} 
                  params={params}
                  locations={locations}
                />
              :
              <div className="results-section px-md-4">
                <Row noGutters={true} className="item-wrapper rounded">
                  <Col>
                    {t("noResults")}
                  </Col>
                </Row>
              </div>
            }
          </Col>
        </Row>
      )}
    </Container>
  );
}

const mapStateToProps = ({ vendors, results, ui, currencies, locations }) => ({
  vendors: vendors.data,
  vendorsLoaded: vendors.loaded,
  vendorsLoading: vendors.loading,
  vendorsLastCheck: vendors.lastCheck,
  results: results.data,
  resultsLastCheck: results.lastCheck,
  resultsLoaded: results.loaded,
  loading: ui.loading,
  dir: ui.direction,
  cur: ui.currency,
  currencies: currencies.data,
  locations: locations.data,
});

export default connect(mapStateToProps)(Search);
